import { makeLazy } from "lib/make-lazy"
import { bind } from "lib/@components/binding/bind"

const DocumentListEditor = makeLazy(
    () => import("lib/@components/document-viewer/document-list-editor-load"),
    "DocumentListEditor"
)
export const BoundDocumentListEditor = bind(<DocumentListEditor />, { extract: (v) => v, default: {} })
